import Vue from 'vue';
import messageHint from './messageHint';

let instance;

const fnTypes = ['show'];

const MessageHintConstruct = Vue.extend(messageHint);

const MessageHint = function(options = {}) {
  if (!instance) {
    instance = new MessageHintConstruct({
      data: options
    });
    instance.$mount();
    document.body.appendChild(instance.$el);
  } else {
    Object.assign(instance.$data, options);
  }
  return instance;
};

fnTypes.forEach(type => {
  MessageHint[type] = options => MessageHint(options).open();
});

MessageHint.hide = () => {
  instance && instance.close();
};

MessageHint.destroy = () => {
  instance && instance.destroy();
};

export default MessageHint;
